// extracted by mini-css-extract-plugin
export default {"estateCardHorizontal":"style_estateCardHorizontal__Lsbxj","opacityAnimation":"style_opacityAnimation__Pplg+","estateCardVertical":"style_estateCardVertical__AcHJm"};